import React, { useEffect, useState } from 'react'

import { useConfigurationStore, useFreeSpinsBonusesStore } from '@stores'
import { useFormatMoney } from '@hooks'

import spritesheetSrc from '@assets/bonus-system/gift-animation.png'
import animatedSpriteConfig from '@assets/bonus-system/gift-animation.json'
import { Bonus } from 'game-ui-types'
import { useTranslation } from '@amusnet/translations/react'
import { AnimatedSprite } from '@amusnet/react-ui'

interface FSSingleBonusProps {
    updateSelectedBonus: (bonus: Bonus) => void
}

const FSSingleBonus: React.FC<FSSingleBonusProps> = ({ updateSelectedBonus }: FSSingleBonusProps) => {
    const { t } = useTranslation()
    const formatMoney = useFormatMoney()
    const bonuses = useFreeSpinsBonusesStore((state) => state.bonuses)
    const currency = useConfigurationStore((state) => state.currency)

    const [betValue, setBetValue] = useState('')
    const [bundleType, setBundleType] = useState('')

    useEffect(() => {
        if (bonuses.length === 1) {
            const newBundleType = t('gameui.bonusSystem.freeSpin', undefined, Number(bonuses[0].remainingAmount))

            updateSelectedBonus(bonuses[0])
            setBundleType(newBundleType)
            setBetValue(formatMoney(Number(bonuses[0].betValue)))
        }
    }, [bonuses, formatMoney])

    return (
        <div id="fs-single-bonus" className="flex flex-col items-center justify-between">
            <div id="fs-single-bonus-content" className="flex flex-col w-full bg-[#19191C]">
                <AnimatedSprite
                    spritesheetSrc={spritesheetSrc}
                    config={animatedSpriteConfig}
                    duration={1.5}
                    className="m-auto"
                />

                <div
                    id="freespin-bonus-text"
                    className="flex flex-col items-center w-full pb-4 bg-[linear-gradient(180deg,#19191C_19.44%,#793F06_100%)]"
                >
                    <p id="fs-single-bonus-congratulations" className="text-4xl font-bold text-white">
                        {t('gameui.congratulations')}
                    </p>
                    <p id="fs-single-bonus-you-get" className="text-4xl font-bold text-white">
                        {t('gameui.bonusSystem.youGet')}
                    </p>
                    <p id="fs-single-bonus-amount" className="text-9xl font-black text-yellow-400 leading-tight">
                        {bonuses[0].remainingAmount}
                    </p>
                    <p id="fs-single-bonus-type" className="text-4xl font-black text-yellow-400 leading-snug">
                        {bundleType}
                    </p>
                    <p id="fs-single-bonus-bet-amount" className="text-4xl font-bold text-white">
                        x {betValue} {currency}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default FSSingleBonus
